

import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Table,
  Form,
  Input,
  Button,
  Modal,
  Skeleton,
  Spin,
  Result,
  TimePicker,
} from "antd";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../store";
import {
  getScheduleRequest,
  createScheduleRequest,
  updateScheduleRequest,
  resetSuccessSchedule,
  resetMessageSchedule,
} from "../../slices/schedule"; // Sesuaikan dengan slice schedule
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const ScheduleSetting: React.FC = () => {
  const dispatch = useDispatch();
  const [formAdd] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState<any>(null);
  const [isAddMode, setIsAddMode] = useState(false);

  const {
    scheduleList,
    loading,
    isSuccess,
    messageErr,
    isUpdate,
    isCreate,
  } = useTypedSelector((state) => ({
    scheduleList: state.Schedule.scheduleList, // Sesuaikan dengan reducer schedule
    loading: state.Schedule.pageIsLoading,
    isSuccess: state.Schedule.isSuccess,
    messageErr: state.Schedule.message,
    isUpdate: state.Schedule.scheduleUpdate,
    isCreate: state.Schedule.schedulePost,
  }));

  useEffect(() => {
    dispatch(getScheduleRequest() as any);
  }, [isUpdate, isCreate]);

  useEffect(() => {
    if (editingSchedule) {
      formEdit.setFieldsValue({
        ...editingSchedule,
        timeIn: editingSchedule.timeIn
          ? dayjs(editingSchedule.timeIn, "HH:mm:ss").isValid()
            ? dayjs(editingSchedule.timeIn, "HH:mm:ss")
            : null
          : null,
        timeOut: editingSchedule.timeOut
          ? dayjs(editingSchedule.timeOut, "HH:mm:ss").isValid()
            ? dayjs(editingSchedule.timeOut, "HH:mm:ss")
            : null
          : null,
      });
    }
  }, [editingSchedule]);
  
  

  const columns = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
        title: "Time In",
        dataIndex: "timeIn",
        key: "timeIn",
        render: (time: string) =>
          time ? (dayjs(time, "HH:mm:ss").isValid() ? dayjs(time, "HH:mm:ss").format("HH:mm:ss") : "Not Time") : "-",
      },
      {
        title: "Time Out",
        dataIndex: "timeOut",
        key: "timeOut",
        render: (time: string) =>
          time ? (dayjs(time, "HH:mm:ss").isValid() ? dayjs(time, "HH:mm:ss").format("HH:mm:ss") : "Not Time") : "-",
      },
      
      
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <Button
          type="primary"
          style={{ backgroundColor: "#faad14", borderColor: "#faad14" }}
          onClick={() => handleEdit(record)}
        >
          Edit
        </Button>
      ),
    },
  ];

  const handleEdit = (schedule: any) => {
    setEditingSchedule({
      ...schedule,
      timeIn: schedule.timeIn
        ? dayjs(schedule.timeIn, "HH:mm:ss").isValid()
          ? dayjs(schedule.timeIn, "HH:mm:ss")
          : null
        : null,
      timeOut: schedule.timeOut
        ? dayjs(schedule.timeOut, "HH:mm:ss").isValid()
          ? dayjs(schedule.timeOut, "HH:mm:ss")
          : null
        : null,
    });
    setIsEditing(true);
  };
  

  const handleCancel = () => {
    setIsEditing(false);
    setEditingSchedule(null);
    setOpenModal(false);
    dispatch(resetMessageSchedule());
    dispatch(resetSuccessSchedule());
    formAdd.resetFields();
    formEdit.resetFields();
  };

  const showConfirmationModal = (values: any, isAdd: boolean) => {
    setModalData(values);
    setIsAddMode(isAdd);
    setOpenModal(true);
  };

  const handleModalOk = () => {
    if (isAddMode) {
      onFinish(modalData);
    } else {
      onFinishUpdate(modalData);
    }
  };

  const onFinish = (values: any) => {
    const { timeIn, timeOut, ...rest } = values;
    dispatch(
      createScheduleRequest({
        ...rest,
        timeIn: timeIn ? dayjs(timeIn).format("HH:mm:ss") : null,
        timeOut: timeOut ? dayjs(timeOut).format("HH:mm:ss") : null,
      }) as any
    );
  };
  
  

  const onFinishUpdate = (values: any) => {
    const { timeIn, timeOut, ...rest } = values;
    dispatch(
      updateScheduleRequest({
        ...editingSchedule,
        ...rest,
        timeIn: timeIn ? dayjs(timeIn).format("HH:mm:ss") : null,
        timeOut: timeOut ? dayjs(timeOut).format("HH:mm:ss") : null,
      }) as any
    );
  };
  
  

  return (
    <div style={{ marginTop: 20 }}>
      <Row gutter={16}>
        <Col span={16}>
          {!loading ? (
            <Table columns={columns} dataSource={scheduleList} rowKey="_id" />
          ) : (
            <Skeleton active />
          )}
        </Col>

        <Col span={8}>
          <div
            style={{
              backgroundColor: "#EEEEEE",
              marginBottom: 2,
              marginLeft: 10,
              borderColor: "#eaeaea",
              borderStyle: "solid",
              borderRadius: "7px",
              padding: 20,
            }}
          >
            <h4>Add Schedule</h4>
            <Form
              form={formAdd}
              layout="vertical"
              onFinish={(values) => showConfirmationModal(values, true)}
              style={{ maxWidth: 400, margin: "0 auto" }}
            >
              <Form.Item
                label="Code"
                name="code"
                rules={[
                  {
                    required: true,
                    message: "Please input the schedule code!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Time In"
                name="timeIn"
                rules={[
                  {
                    required: true,
                    message: "Please select time in!",
                  },
                ]}
              >
                <TimePicker format="HH:mm:ss" />
              </Form.Item>

              <Form.Item
                label="Time Out"
                name="timeOut"
                rules={[
                  {
                    required: true,
                    message: "Please select time out!",
                  },
                ]}
              >
                <TimePicker format="HH:mm:ss" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginRight: 20 }}
                >
                  Submit
                </Button>
                <Button onClick={handleCancel}>Cancel</Button>
              </Form.Item>
            </Form>
          </div>

          {isEditing && (
            <div
              style={{
                backgroundColor: "#E4E0E1",
                marginTop: 15,
                marginLeft: 10,
                borderColor: "#eaeaea",
                borderStyle: "solid",
                borderRadius: "7px",
                padding: 20,
              }}
            >
              <h4>Edit Schedule</h4>
              <Form
                form={formEdit}
                layout="vertical"
                onFinish={(values) =>
                  showConfirmationModal(
                    { ...editingSchedule, ...values },
                    !isEditing
                  )
                }
                initialValues={editingSchedule || {}}
                style={{ maxWidth: 400, margin: "0 auto" }}
              >
                <Form.Item
                  label="Code"
                  name="code"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please input the schedule code!",
                  //   },
                  // ]}
                >
                  <Input disabled={true}/>
                </Form.Item>

                <Form.Item
                  label="Time In"
                  name="timeIn"
                  rules={[
                    {
                      required: true,
                      message: "Please select time in!",
                    },
                  ]}
                >
                  <TimePicker format="HH:mm:ss" />
                </Form.Item>

                <Form.Item
                  label="Time Out"
                  name="timeOut"
                  rules={[
                    {
                      required: true,
                      message: "Please select time out!",
                    },
                  ]}
                >
                  <TimePicker format="HH:mm:ss" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      marginRight: 20,
                      backgroundColor: "#faad14",
                      borderColor: "#faad14",
                    }}
                  >
                    Update
                  </Button>
                  <Button onClick={handleCancel}>Cancel & Close</Button>
                </Form.Item>
              </Form>
            </div>
          )}
        </Col>
      </Row>

      <Modal
        open={openModal}
        title="Confirm Action"
        onCancel={handleCancel}
        cancelText="Close"
        onOk={handleModalOk}
        okButtonProps={
          isSuccess || messageErr.length > 0
            ? { style: { display: "none" } }
            : {}
        }
      >
        <p>
          {isAddMode
            ? "Are you sure you want to add this schedule?"
            : "Are you sure you want to edit this schedule?"}
        </p>
        <Spin
          spinning={loading}
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        >
          {isSuccess && (
            <Result status="success" title="Successfully updated schedule" />
          )}
          {messageErr.length > 0 && (
            <Result status="error" title="Error" subTitle={messageErr} />
          )}
        </Spin>
      </Modal>
    </div>
  );
};

export default ScheduleSetting;
